export enum ELegType {
  CAR = 'CAR',
  PLANE = 'PLANE',
}
